const initialState = {
  pollMap: {},
};

const poll = (state = initialState, action) => {
  switch (action.type) {
    case "GET_POLL": {
      let pollMap = state.pollMap;
      let pollId = action.payload.id;
      pollMap[pollId] = action.payload;
      return { ...state, pollMap: { ...pollMap } };
    }
    case "ADD_ANSWER_TO_POLL": {
      let pollMap = state.pollMap;
      let pollId = action.payload.id;
      let choices = action.choices;
      action.payload.answered = choices;
      pollMap[pollId] = action.payload;
      return { ...state, pollMap: { ...pollMap } };
    }
    case "GET_POLL_DETAILS": {
      let pollMap = state.pollMap;
      let pollId = action.payload.id;
      pollMap[pollId] = {
        ...pollMap[pollId],
        detail: { answers: action.payload.answers },
      };
      return { ...state, pollMap: { ...pollMap } };
    }
    default:
      return state;
  }
};

export default poll;
